// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MembershipDocumentListPagingResultModel from '../../model/membership-document-list-paging-result-model';
import MembershipDocumentListPagingResultDTO from '../dto/membership-document-list-paging-result-dto';
import dtoSchema from '../schemas/membership-document-list-paging-result-schema';
import MembershipDocumentListModel from '../../model/membership-document-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class MembershipDocumentListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MembershipDocumentListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => MembershipDocumentListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: MembershipDocumentListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<MembershipDocumentListPagingResultDTO>): MembershipDocumentListPagingResultModel;
  static toModel(dto: DeepPartial<MembershipDocumentListPagingResultDTO> | undefined | null): MembershipDocumentListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<MembershipDocumentListPagingResultDTO> | undefined | null): MembershipDocumentListPagingResultModel | undefined {
    return dto ? new MembershipDocumentListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MembershipDocumentListPagingResultModel> | MembershipDocumentListPagingResultModel): MembershipDocumentListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as MembershipDocumentListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MembershipDocumentListPagingResultModel, can not map to MembershipDocumentListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
